module.exports = __webpack_public_path__ + "static/media/RI-D5-0.4-042.d7a20e62.webp";